import { useMarketplaceIdentity } from "@hooks/useMarketplaceIdentity";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { clearVisitNewBadgeIds } from "./myRequestsReadState";

/**
 * Clears per-visit NEW badges when navigating away from My Requests.
 * Mounted at app level so leave is detected even if the page tree unmounts late.
 */
export function useMyRequestsRouteVisit() {
  const { pathname } = useLocation();
  const { sub } = useMarketplaceIdentity();
  const isOnMyRequestsRef = useRef(pathname === "/my-requests");

  useEffect(() => {
    const wasOnMyRequests = isOnMyRequestsRef.current;
    const isOnMyRequests = pathname === "/my-requests";

    if (wasOnMyRequests && !isOnMyRequests && sub) {
      clearVisitNewBadgeIds(sub);
    }

    isOnMyRequestsRef.current = isOnMyRequests;
  }, [pathname, sub]);
}
